import { api } from '../api';

export interface OfertaPublica {
  legajoId: string;
  legajoNumero: string;
  expiraAt: string;
  yaAceptada: boolean;
  tmk: { nombre?: string; email?: string };
  titular: { nombres: string; apellido: string };
  cantidadIntegrantes: number;
  montoMs2: number;
  planNombre: string;
  tycMs2: { versionDocumento: string };
}

export interface IniciarPagoResp {
  modo: 'redirect' | 'directo';
  estado: string;
  urlCheckout?: string;
  referenciaExterna?: string;
  externalId?: string;
  motivoRechazo?: string;
  intentos: number;
  max: number;
}

export async function getOferta(token: string): Promise<OfertaPublica> {
  const { data } = await api.get<OfertaPublica>(`/portal/oferta/${token}`);
  return data;
}

export async function aceptarOfertaYPagar(token: string): Promise<IniciarPagoResp> {
  const { data } = await api.post<IniciarPagoResp>(
    `/portal/oferta/${token}/aceptar-y-pagar`,
    {},
  );
  return data;
}

/**
 * TMK / Medicus: dispara la generación de la oferta para un legajo.
 * `email` solo se manda cuando el titular no tiene uno cargado (el server lo
 * persiste en su ficha); si ya tiene, se ignora.
 */
export async function enviarOfertaTmk(
  legajoId: string,
  email?: string,
): Promise<{
  token: string;
  expiraAt: string;
  emailDestinatario: string;
}> {
  const { data } = await api.post(`/tmk/oferta/legajo/${legajoId}/enviar`, email ? { email } : {});
  return data;
}

/** TMK / SkyTel / admin: genera (o reusa) el link público de la oferta SIN mandar mail. */
export async function copiarLinkOferta(legajoId: string): Promise<{
  ok: true;
  link: string;
  expiraAt: string;
  /** El titular ya eligió MS2 (el link sirve igual para reintentar). */
  yaAceptada: boolean;
  /** Ya había una oferta vigente: se reusó el mismo link. */
  linkPreexistente: boolean;
  /** Estado del pago si hubo un intento (pendiente/rechazado/...). */
  pagoEstado: string | null;
}> {
  const { data } = await api.post(`/tmk/oferta/legajo/${legajoId}/link`, {});
  return data;
}

// ─── Worklist del TMK (precarga de "quiero que me contacten") ───────────────

export interface TmkWorklistItem {
  legajoId: string;
  numero: string;
  estado: string;
  titular: { nombres: string; apellido: string; documento: string; email: string };
  cantidadIntegrantes: number;
  montoMs2: number;
  solicitadoAt?: string;
  ofertaVigente: boolean;
  ofertaExpiraAt?: string;
  yaAcepto: boolean;
  pagoEstado?: string;
}

export interface TmkWorklistPage {
  items: TmkWorklistItem[];
  total: number;
  page: number;
  pageSize: number;
}

/** Lista paginada de legajos que pidieron "que me contacten" (pendientes). */
export async function getTmkWorklist(page = 1, pageSize = 50): Promise<TmkWorklistPage> {
  const { data } = await api.get<TmkWorklistPage>('/tmk/oferta/worklist', {
    params: { page, pageSize },
  });
  return data;
}

/** Marca el pedido de contacto como resuelto (lo saca de la worklist). */
export async function resolverContactoTmk(legajoId: string): Promise<{ ok: true }> {
  const { data } = await api.post<{ ok: true }>(`/tmk/oferta/legajo/${legajoId}/resolver`, {});
  return data;
}
